import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Button, ReduxControls } from 'rhombus-react';
import { reduxForm, reset, isValid, initialize, Field, getFormValues } from "redux-form";

import { CREATE_BLANK_IMPOSIUM_AUDIO_FORM, ADD_AUDIO_CREATIVES_TO_IMPOSIUM_PROJECT_FORM, IMPOSIUM_AUDIO_MULTI_CREATIVE_FORM } from "widgets/forms/list";
import BasicModal from "widgets/modals/BasicModal";

import NewImposiumAudioWithCreativesForm from "widgets/modals/imposium/NewImposiumAudioWithCreativesForm";
import AddAudioCreativesToImposiumProjectModal from "widgets/modals/imposium/AddAudioCreativesToImposiumProjectModal";
import ImposiumProjectsTable from "widgets/modals/imposium/ImposiumProjectsTable";

import "./CreateImposiumProjectModal.css";


export function ImposiumAudioMultiCreativeModal(props) {
	const { navigationActions, onClose, initialized } = props;
	const dispatch = useDispatch();
	const libraryId = useSelector(state => state.libraryProperties.id);
	const isSaving = useSelector(state => state.imposiumProjects.isSaving);
	const selectedProject = useSelector(state => state.imposiumProjects.selectedProject);

	const values = useSelector(getFormValues(IMPOSIUM_AUDIO_MULTI_CREATIVE_FORM)) || {};
	const useExistingProject = values?.newOrExistingProject === 'existingProject';

	useEffect(() => {
		if (!initialized) {
			dispatch(initialize(IMPOSIUM_AUDIO_MULTI_CREATIVE_FORM, { newOrExistingProject: 'newProject' }));
		}
	}, [initialized]);

	const isNewProjectValid = useSelector(isValid(CREATE_BLANK_IMPOSIUM_AUDIO_FORM));
	const newProjectFormValues = useSelector(getFormValues(CREATE_BLANK_IMPOSIUM_AUDIO_FORM)) || {};
	const valid = useExistingProject ? !!selectedProject : isNewProjectValid;

	function onBack() {
		dispatch(reset(CREATE_BLANK_IMPOSIUM_AUDIO_FORM));
		dispatch(reset(ADD_AUDIO_CREATIVES_TO_IMPOSIUM_PROJECT_FORM));
		dispatch(reset(IMPOSIUM_AUDIO_MULTI_CREATIVE_FORM));
		navigationActions?.popModal();
	}

	function onExit() {
		dispatch(reset(CREATE_BLANK_IMPOSIUM_AUDIO_FORM));
		dispatch(reset(ADD_AUDIO_CREATIVES_TO_IMPOSIUM_PROJECT_FORM));
		dispatch(reset(IMPOSIUM_AUDIO_MULTI_CREATIVE_FORM));
		onClose();
	}

	function openAddCreativesModal() {
		function addCreativesModal(modalProps) {
			return (
				<AddAudioCreativesToImposiumProjectModal
					{...modalProps}
					navigationActions={navigationActions}
					libraryId={libraryId}
					selectedProject={selectedProject}
					onClose={onExit}
				/>
			);
		}
		navigationActions.pushModal(addCreativesModal);
	}

	function renderContent() {
		return (
			<div>
				<header className="header-imposium">
					<Field
						name="newOrExistingProject"
						component={ReduxControls.Checkbox}
						label="New Imposium Project"
						value="newProject"
						type="radio"
					/>
					<Field
						name="newOrExistingProject"
						component={ReduxControls.Checkbox}
						label="Select Existing Imposium Project"
						value="existingProject"
						type="radio"
					/>
				</header>
				<div className="imposium-modal-main-content">
					{useExistingProject ? <ImposiumProjectsTable libraryId={libraryId} /> : <NewImposiumAudioWithCreativesForm onClose={onExit} libraryId={libraryId} />
					}
				</div>
			</div>
		);
	}

	function renderFooter() {
		const creativeCount = newProjectFormValues?.creatives?.length || 0;
		const createButtonText = creativeCount > 1 ? `Create (${creativeCount})` : "Create";

		const createButton = (
			<Button
				key="create"
				disabled={isSaving || !valid}
				type="submit"
				theme="green"
				form={CREATE_BLANK_IMPOSIUM_AUDIO_FORM}
			>
				{createButtonText}
			</Button>
		);

		const selectButton = (
			<Button
				key="selectProject"
				disabled={!selectedProject}
				theme="blue"
				onClick={openAddCreativesModal}
			>
				Select Imposium Project
			</Button>
		);

		return [
			<Button key="back" theme="default" onClick={onBack}>Back</Button>,
			useExistingProject ? selectButton : createButton,
		];
	}

	const modalProps = {
		title: "Create Dynamic Audio - Imposium",
		onClose: onExit,
		className: "create-imposium-project-modal create-imposium-project-multi-creative",
		renderContent,
		renderFooter,
	};

	return <BasicModal {...modalProps} />;
}

ImposiumAudioMultiCreativeModal.displayName = "ImposiumAudioMultiCreativeModal";

export default reduxForm({
	form: IMPOSIUM_AUDIO_MULTI_CREATIVE_FORM,
	destroyOnUnmount: false,
})(ImposiumAudioMultiCreativeModal);
